import { store } from "@/store";

export const can = (action, subject) => {
  console.log(store.getters["user/abilities"])
  const abilities = store.getters["user/abilities"];
  return abilities.can(action, subject);
};
